import {Box, Popover, PopoverBody, PopoverButton, PopoverContent} from "@deere/fuel-react";
import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {ReactComponent as InfoIcon} from "../shared/icons/info.svg";

export const ClassificationGuidelinesPopOver = () => {

    function createData(classification, pointsEarned, description) {
        return { classification, pointsEarned, description};
    }

    const rows = [
        createData("Partner", "480 - 500", "A supplier who exceeds our performance standards, has reached world-class."),
        createData("Key", "430 - 479", "A supplier who exceeds our minimum standards and is working toward world-class."),
        createData("Approved", "380 - 429", "A supplier that meets minimum performance standards."),
        createData("Conditional", "379 or less", "A supplier who does not meet minimum performance standards and is a possible candidate for removal from the John Deere supply base."),
    ];


    return (
        <Box>

            <Popover>
                <PopoverButton variant={"text-inline"}>
                    <InfoIcon />
                </PopoverButton>
                <PopoverContent>
                    <PopoverBody sx={{ minWidth: 250, maxWidth: "45vw"}}>
                        <TableContainer variant={"outline"}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size={"small"}>
                                <TableHead>
                                    <TableRow style={{backgroundColor: "#ffde00"}}>
                                        <TableCell>Final Classification</TableCell>
                                        <TableCell>Total Points Earned</TableCell>
                                        <TableCell>Description</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow key={row.classification}>
                                            <TableCell>{row.classification}</TableCell>
                                            <TableCell>{row.pointsEarned}</TableCell>
                                            <TableCell>{row.description}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        </Box>
    );
}

